module.exports = __webpack_public_path__ + "img/shebeixinxi.335d238a.svg";